import React from "react";
import {
    Form,
    Button
} from 'antd';
import AuthLogic from '../../AuthLogic'

const WorkerContactDetails = ({ resource, ...props }) => {

    const sanatizePhoneNumber = (number) => {
        const scrubedNumber = number.match(/\d/g).join('');
        if (scrubedNumber.length === 10) {
            const part1 = scrubedNumber.slice(0, 3);
            const part2 = scrubedNumber.slice(3, 6);
            const part3 = scrubedNumber.slice(6, 10);

            return part1 + '-' + part2 + '-' + part3;
        }
        return number;
    }

    const cellPhone = resource && resource.cellularPhone ? sanatizePhoneNumber(resource.cellularPhone) : '';
    const homePhone = resource && resource.homePhone ? sanatizePhoneNumber(resource.homePhone) : '';
    const workPhone = resource && resource.workPhone ? sanatizePhoneNumber(resource.workPhone) : '';
    const otherPhone = resource && resource.otherPhone ? sanatizePhoneNumber(resource.otherPhone) : '';

    const activityServices = () => {
        if (!resource.activityService) {
            return;
        }
        return (
            <React.Fragment>
                {resource.activityService && resource.activityService.length > 0 && <div><b>Activity Services: </b></div>}
                {resource.activityService.map(service => (
                    <div>{service.ServiceName}</div>
                ))}
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            {resource.name && <div><b>Name: </b>{resource.name}</div>}
            {AuthLogic.resourceInfoSSO(props.user) && resource.sso &&
                <div><b>SSO: </b>{resource.sso}</div>
            }
            {resource.divisionName && <div><b>Division: </b>{resource.divisionName}</div>}
            {resource.departmentName && <div><b>Cost Center Name: </b>{resource.departmentName}</div>}
            {resource.activityType && <div><b>Activity Type: </b>{resource.activityType}</div>}
            {resource.cellularPhone &&
                <React.Fragment>
                    <div><b>Cell Phone: </b>{resource.cellularPhone}</div>
                    <Button className="contact-info-button" href={`tel:${cellPhone}`}>Call Cell Phone</Button>
                    <Button className="contact-info-button" href={`sms:${cellPhone}`}>Text Cell Phone</Button>
                </React.Fragment>
            }
            {resource.homePhone &&
                <React.Fragment>
                    <div><b>Home Phone: </b>{resource.homePhone}</div>
                    <Button className="contact-info-button" href={`tel:${homePhone}`}>Call Home Phone</Button>
                    <Button className="contact-info-button" href={`sms:${homePhone}`}>Text Home Phone</Button>
                </React.Fragment>
            }
            {resource.workPhone &&
                <React.Fragment>
                    <div><b>Work Phone: </b>{resource.workPhone}</div>
                    <Button className="contact-info-button" href={`tel:${workPhone}`}>Call Work Phone</Button>
                    <Button className="contact-info-button" href={`sms:${workPhone}`}>Text Work Phone</Button>
                </React.Fragment>
            }
            {resource.pagerPhone && <div><b>Pager: </b>{resource.pagerPhone}</div>}
            {resource.faxPhone &&<div><b>Fax: </b>{resource.faxPhone}</div>}
            {resource.otherPhone &&
                <React.Fragment>
                    <div><b>Other Phone: </b>{resource.otherPhone}</div>
                    <Button className="contact-info-button" href={`tel:${otherPhone}`}>Call Other Phone</Button>
                    <Button className="contact-info-button" href={`sms:${otherPhone}`}>Text Other Phone</Button>
                </React.Fragment>
            }
            {resource.workEmail && <div><b>Work Email: </b>{resource.workEmail}</div>}
            {resource.privateEmail && <div><b>Private Email: </b>{resource.privateEmail}</div>}
            {activityServices()}
        </React.Fragment>
    );
}

const WrappedWorkerContactDetails = Form.create()(WorkerContactDetails);

export default WrappedWorkerContactDetails;




// WEBPACK FOOTER //
// ./src/Components/Schedule/WorkerContactDetails.js